import { Box, Divider } from "@chakra-ui/react";
import { WriteLeftDotLine } from "./WriteLeftDotLine";

export const AddMarginLeft = ({ children }: { children: React.ReactNode }) => {
  return (
    <WriteLeftDotLine>
      <Box ml={5} data-testid={"add-margin-left"}>
        {/* <Divider
          mx={4}
          orientation="vertical"
          borderColor="gray.200"
          borderStyle="dotted"
          borderLeftWidth={2}
          borderRightWidth={0}
          borderTopWidth={0}
          borderBottomWidth={0}
        /> */}
      </Box>
      {children}
    </WriteLeftDotLine>
  );
};
